import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入Status管理
import store from './vuex/store';
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts


import global from './utils/global.js'
Vue.prototype.global = global

import axios from 'axios';
Vue.prototype.$axios = axios;
import VueKindEditor from './plugin/kindeditor.js'
import '../static/kindeditor/themes/default/default.css'
import '../static/kindeditor/kindeditor-all-min.js'
import '../static/kindeditor/lang/zh-CN.js'
Vue.use(VueKindEditor)
Vue.config.productionTip = false;

import {
  Message
} from 'element-ui'
Vue.prototype.$message = Message

// 使用element UI
Vue.use(ElementUI, {
  locale
});
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

new Vue({
  el: '#app',
  router,
  store, //使用store vuexStatus管理
  components: {
    App
  },
  template: '<App/>',
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }

})



// WEBPACK FOOTER //
// ./src/main.js